import state from './presentation.state'
import mutations from './presentation.mutations'
import actions from './presentation.actions'

export default {
  state,
  mutations,
  actions
}
